import { useEffect } from 'react';
import { useAppDispatch } from '@app/hooks';
import { STORAGE_KEY, setTheme } from './slice';

/**
 * Тема переключается во всех окнах ОСНОВЫ сразу (ТЗ Диска 6.1.1): другое окно
 * записало выбор в localStorage — это окно получает событие `storage` и
 * применяет ту же тему. Своё окно событие не получает — петли нет.
 */
export function useThemeSync(): void {
  const dispatch = useAppDispatch();
  useEffect(() => {
    const onStorage = (e: StorageEvent) => {
      if (e.key !== STORAGE_KEY) return;
      if (e.newValue === 'light' || e.newValue === 'dark') dispatch(setTheme(e.newValue));
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, [dispatch]);
}
